module.exports = __webpack_public_path__ + "459a23cd88997cbb84e335d6352e91d7.png";